import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=610bd53c&scoped=true"
import script from "./Templates.ts?vue&type=script&lang=ts&external"
export * from "./Templates.ts?vue&type=script&lang=ts&external"
import style0 from "./templates.scss?vue&type=style&index=0&id=610bd53c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610bd53c",
  null
  
)

export default component.exports